/*
 * @Descripttion:
 * @version:
 * @Author: 周志国
 * @Date: 2025-09-10 14:24:00
 * @LastEditors: 周志国
 * @LastEditTime: 2025-09-10 14:38:28
 * @changeLog:
 * @FilePath: /anov-3d-webgl/packages/anov-3d-ability/src/business/Box/interface.ts
 */

// ./interface.ts
import type { Mesh } from '@anov/3d-core'
import type { options } from './types'

export interface IBox {
  /** 创建立方体 */
  createBox: (options: options) => Mesh
  /** 更新立方体 */
  updateBox: (options: options) => void
  /** 销毁立方体 */
  destroy: () => void
}
